/*
 * This file is part of the https://gitlab-intern.easd-support.de/easd/p26s26_energie_watchdog project.
 *
 * (c) 2026 EA Systems Dresden GmbH
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

/* Import types */
import type { MermaidFlowchartNodeVariant } from '@/lib/presentation/mermaidDiagram';

export type ComponentOverviewTheme = 'dark' | 'light';

export interface ComponentOverviewNodeColor {
    backgroundColor: string;
    borderColor: string;
    textColor: string;
}

export const COMPONENT_OVERVIEW_NODE_COLORS: Record<
    ComponentOverviewTheme,
    Record<MermaidFlowchartNodeVariant, ComponentOverviewNodeColor>
> = {
    dark: {
        application: { backgroundColor: '#5f1d1d', borderColor: '#f87171', textColor: '#fef2f2' },
        component: { backgroundColor: '#163a5f', borderColor: '#60a5fa', textColor: '#eff6ff' },
        context: { backgroundColor: '#5f4a12', borderColor: '#facc15', textColor: '#fefce8' },
        external: { backgroundColor: '#3f3f46', borderColor: '#a1a1aa', textColor: '#fafafa' },
        route: { backgroundColor: '#14532d', borderColor: '#4ade80', textColor: '#f0fdf4' },
    },
    light: {
        application: { backgroundColor: '#fef2f2', borderColor: '#dc2626', textColor: '#7f1d1d' },
        component: { backgroundColor: '#eff6ff', borderColor: '#2563eb', textColor: '#172554' },
        context: { backgroundColor: '#fefce8', borderColor: '#ca8a04', textColor: '#713f12' },
        external: { backgroundColor: '#f4f4f5', borderColor: '#71717a', textColor: '#27272a' },
        route: { backgroundColor: '#f0fdf4', borderColor: '#16a34a', textColor: '#14532d' },
    },
};
